'use strict';

var FaresOptimizerDashboardConfig = function FaresOptimizerDashboardConfig($stateProvider) {
  $stateProvider.state('app.fares-optimizer-dashboard', {
    url: '/workflow/fares-optimizer-dashboard',
    params: {
      transitionData: null
    },
    views: {
      '': {
        template: '<rm-fares-optimizer-dashboard></rm-fares-optimizer-dashboard>'
      }
    }
  });
};
module.exports = FaresOptimizerDashboardConfig;
FaresOptimizerDashboardConfig.$inject = ['$stateProvider'];